import { Key } from 'react';
import {
  allTargetDomainsSelector,
  allTargetAppsSelector,
  availableTargetsGeneralTeamsSelector,
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '../store';

import { TargetType } from 'src/utils/enums';
import {
  policyTargetsSalesforceProfileSelector,
  policyTargetsInlineSelector,
  policyTargetsSelector,
  targetDomainsSelector,
  policyTargetsSalesforceAppsSelector,
  policyTargetsSalesforceObjectsSelector,
} from '@Policy/store/filters/general/store';
import isEqual from 'lodash/isEqual';
import { unCheckTargetGroup } from '@Policy/utils/fns';
import { Service } from '@Types/app';

export const useExchangeOnlineTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  // searchTarget need pass keyword and targetType, targetType is userGroup by default
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);
  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useLocalAccountsTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllLocalAccountsTargets);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificLocalAccountsTargets
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => unCheckTargetGroup(s.availableTargetsGerneral),
    isEqual
  );
  // searchTarget need pass keyword and targetType, targetType is userGroup by default
  const searchTarget = contextSelector((s) => s.searchLocalAccountTargetsBase);
  const searchTargetResult = contextSelector(
    (s) => unCheckTargetGroup(s.tempVars.searchTargetUserGroups),
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);
  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useExchangeOnlineHpuTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllHpuTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificHpuTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => unCheckTargetGroup(s.availableTargetsGerneral),
    isEqual
  );
  // searchTarget need pass keyword and targetType, targetType is userGroup by default
  const searchTarget = contextSelector((s) => s.searchHpuTargetByService);
  const searchTargetResult = contextSelector(
    (s) => unCheckTargetGroup(s.tempVars.searchTargetUserGroups),
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);
  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useOneDriveTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useSharePointTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useGmailTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useGmailHpuTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllHpuTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificHpuTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => unCheckTargetGroup(s.availableTargetsGerneral),
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchHpuTargetByService);
  const searchTargetResult = contextSelector(
    (s) => unCheckTargetGroup(s.tempVars.searchTargetUserGroups),
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useGmailInboundTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector(
    (s) => s.handleToRightTargetsGmailInline
  );
  const handleDeleteTarget = contextSelector(
    (s) => s.handleDeleteTargetGmailInline
  );
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = contextSelector(policyTargetsInlineSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useGmailInlineTargetDomains = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetDomainsByService);
  // do not need a function to get specific target
  const getSpecificTarget = async (expandedKeys: Key[]) => {
    console.log(expandedKeys);
  };
  const handleToRight = contextSelector((s) => s.handleToRightTargetDomains);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTargetDomain);
  const allTargets = contextSelector(allTargetDomainsSelector, isEqual);
  const syncTargets = contextSelector((s) => s.syncDomainsByService);
  const searchTargetBase = contextSelector((s) => s.searchTargetBase);
  const searchTarget = (searchString: string) =>
    searchTargetBase(searchString, TargetType.Domain);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetDomains,
    isEqual
  );
  // get value from selector from store
  const policyTarget = contextSelector(targetDomainsSelector, isEqual);
  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    allTargets,
    policyTarget,
    syncTargets,
    searchTarget,
    searchTargetResult,
  };
};

export const useExchangeInlineTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargetsInline);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTargetInline);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const policyTarget = contextSelector(policyTargetsInlineSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useExchangeInlineTargetDomains = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetDomainsByService);
  // do not need a function to get specific target
  const getSpecificTarget = async (expandedKeys: Key[]) => {
    console.log(expandedKeys);
  };
  const handleToRight = contextSelector((s) => s.handleToRightTargetDomains);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTargetDomain);
  const syncTargets = contextSelector((s) => s.syncDomainsByService);
  const searchTargetBase = contextSelector((s) => s.searchTargetBase);
  const searchTarget = (searchString: string) =>
    searchTargetBase(searchString, TargetType.Domain);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetDomains,
    isEqual
  );
  // get value from selector from store
  const allTargets = contextSelector(allTargetDomainsSelector, isEqual);
  const policyTarget = contextSelector(targetDomainsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useTeamsTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  // do not need a function to get specific target
  const getSpecificTarget = async (expandedKeys: Key[]) => {
    console.log(expandedKeys);
  };
  const handleToRight = contextSelector((s) => s.handleToRightTargetTeams);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTargetTeams);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const allTargets = contextSelector(
    availableTargetsGeneralTeamsSelector,
    isEqual
  );
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useTeamsChatTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useBoxTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useGoogleDriveTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useBoxExceptionUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  // store the selected exception users in tempVars
  // it just like gmail inline target user groups
  const handleToRight = contextSelector(
    (s) => s.handleToRightTargetsGmailInline
  );
  const handleDeleteTarget = contextSelector(
    (s) => s.handleDeleteTargetGmailInline
  );
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = contextSelector(policyTargetsInlineSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useDropboxTargetUserGroups = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllTargetsByService);
  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificTargetByService
  );
  const handleToRight = contextSelector((s) => s.handleToRightTargets);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTarget);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetsGerneral,
    isEqual
  );
  const searchTarget = contextSelector((s) => s.searchTargetBase);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetUserGroups,
    isEqual
  );
  // get value from selector from store
  const policyTarget = policySelector(policyTargetsSelector, isEqual);

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useTargetAppsSalesforceSandbox = () => {
  const isSyncButtonShow = false;
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllObjectsTargets = contextSelector(
    (s) => s.getAllObjectsTargetsByService
  );
  const getAllCommunitiesTargets = contextSelector(
    (s) => s.getAllCommunitiesTargetsByService
  );
  const getAllTargets = async () => {
    await Promise.all([getAllObjectsTargets(), getAllCommunitiesTargets()]);
  };

  const getSpecificObjectTarget = contextSelector(
    (s) => s.getSpecificObjectTargetByService
  );
  const getSpecificCommunityTarget = contextSelector(
    (s) => s.getSpecificCommunityTargetByService
  );
  const getSpecificTarget = async (targetIds: string[]) => {
    await Promise.all([
      getSpecificObjectTarget(targetIds),
      getSpecificCommunityTarget(targetIds),
    ]);
  };

  const handleToRight = contextSelector((s) => s.handleToRightTargetApps);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTargetApps);

  const syncCommunitiesTargets = contextSelector(
    (s) => s.syncCommunitiesByService
  );
  const syncObjectsTargets = contextSelector((s) => s.syncObjectsByService);
  const syncProfilesTargets = contextSelector((s) => s.syncProfilesByService);
  const syncTargets = async () => {
    // TODO: change func
    await Promise.all([
      syncCommunitiesTargets(),
      syncObjectsTargets(),
      syncProfilesTargets(),
    ]);
  };
  // left tree source data
  const allTargets = contextSelector(allTargetAppsSelector, isEqual);

  const searchCommunitiesTarget = contextSelector(
    (s) => s.searchCommunitiesTargetByService
  );
  const searchObjectsTarget = contextSelector(
    (s) => s.searchObjectsTargetByService
  );
  const searchTarget = async (keyword: string) => {
    const [res1, res2] = await Promise.all([
      searchCommunitiesTarget(keyword),
      searchObjectsTarget(keyword),
    ]);
    return Promise.resolve([...res1, ...res2]);
  };
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetObjects,
    isEqual
  );
  // get value from selector from store
  const policyTarget = contextSelector(
    policyTargetsSalesforceAppsSelector,
    isEqual
  );

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
    isSyncButtonShow,
  };
};

export const useSalesforceSandboxTargetProfilesTarget = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector(
    (s) => s.getAllProfilesTargetsByService
  );

  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificProfileTargetByService
  );

  const handleToRight = contextSelector((s) => s.handleToRightTargetProfiles);
  const handleDeleteTarget = contextSelector(
    (s) => s.handleDeleteTargetProfiles
  );

  const syncTargets = contextSelector((s) => s.syncProfilesByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetProfilesGeneral,
    isEqual
  );

  const searchTarget = contextSelector((s) => s.searchProfilesTargetByService);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetProfiles,
    isEqual
  );
  const policyTarget = contextSelector(
    policyTargetsSalesforceProfileSelector,
    isEqual
  );

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useTargetAppsSalesforceProduction = () => {
  const isSyncButtonShow = false;
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // const policySelector = templateSelector(contextStore);
  // get state and action from store
  const getAllObjectsTargets = contextSelector(
    (s) => s.getAllObjectsTargetsByService
  );
  const getAllCommunitiesTargets = contextSelector(
    (s) => s.getAllCommunitiesTargetsByService
  );
  const getAllTargets = async () => {
    await Promise.all([
      getAllObjectsTargets(false, Service.SalesforceProduction),
      getAllCommunitiesTargets(false, Service.SalesforceProduction),
    ]);
  };

  const getSpecificObjectTarget = contextSelector(
    (s) => s.getSpecificObjectTargetByService
  );
  const getSpecificCommunityTarget = contextSelector(
    (s) => s.getSpecificCommunityTargetByService
  );
  const getSpecificTarget = async (targetIds: string[]) => {
    await Promise.all([
      getSpecificObjectTarget(targetIds),
      getSpecificCommunityTarget(targetIds),
    ]);
  };

  const handleToRight = contextSelector((s) => s.handleToRightTargetApps);
  const handleDeleteTarget = contextSelector((s) => s.handleDeleteTargetApps);

  const syncCommunitiesTargets = contextSelector(
    (s) => s.syncCommunitiesByService
  );
  const syncObjectsTargets = contextSelector((s) => s.syncObjectsByService);
  const syncProfilesTargets = contextSelector((s) => s.syncProfilesByService);
  const syncTargets = async () => {
    // TODO: change func
    await Promise.all([
      syncCommunitiesTargets(),
      syncObjectsTargets(),
      syncProfilesTargets(),
    ]);
  };
  // left tree source data
  const allTargets = contextSelector(allTargetAppsSelector, isEqual);

  const searchCommunitiesTarget = contextSelector(
    (s) => s.searchCommunitiesTargetByService
  );
  const searchObjectsTarget = contextSelector(
    (s) => s.searchObjectsTargetByService
  );
  const searchTarget = async (keyword: string) => {
    const [res1, res2] = await Promise.all([
      searchCommunitiesTarget(keyword),
      searchObjectsTarget(keyword),
    ]);
    return Promise.resolve([...res1, ...res2]);
  };
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetObjects,
    isEqual
  );
  // get value from selector from store
  const policyTarget = contextSelector(
    policyTargetsSalesforceAppsSelector,
    isEqual
  );

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
    isSyncButtonShow,
  };
};

export const useSalesforceProductionProfilesTarget = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargetsProfile = contextSelector(
    (s) => s.getAllProfilesTargetsByService
  );

  const getAllTargets = async () => {
    await getAllTargetsProfile(false, Service.SalesforceProduction);
  };

  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificProfileTargetByService
  );

  const handleToRight = contextSelector((s) => s.handleToRightTargetProfiles);
  const handleDeleteTarget = contextSelector(
    (s) => s.handleDeleteTargetProfiles
  );

  const syncTargets = contextSelector((s) => s.syncProfilesByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetProfilesGeneral,
    isEqual
  );

  const searchTarget = contextSelector((s) => s.searchProfilesTargetByService);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetProfiles,
    isEqual
  );
  const policyTarget = contextSelector(
    policyTargetsSalesforceProfileSelector,
    isEqual
  );

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
  };
};

export const useSalesforceSandboxObjectsTarget = () => {
  const isSyncButtonShow = false;
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargets = contextSelector((s) => s.getAllObjectsTargetsByService);

  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificObjectTargetByService
  );

  const handleToRight = contextSelector((s) => s.handleToRightTargetObjects);
  const handleDeleteTarget = contextSelector(
    (s) => s.handleDeleteTargetObjects
  );

  const syncTargets = contextSelector((s) => s.syncObjectsByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetObjectsGeneral,
    isEqual
  );

  const searchTarget = contextSelector((s) => s.searchObjectsTargetByService);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetObjects,
    isEqual
  );
  const policyTarget = contextSelector(
    policyTargetsSalesforceObjectsSelector,
    isEqual
  );

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
    isSyncButtonShow,
  };
};

export const useSalesforceProductionObjectsTarget = () => {
  const isSyncButtonShow = false;
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const getAllTargetsObject = contextSelector(
    (s) => s.getAllObjectsTargetsByService
  );

  const getAllTargets = async () => {
    await getAllTargetsObject(false, Service.SalesforceProduction);
  };

  const getSpecificTarget = contextSelector(
    (s) => s.getSpecificObjectTargetByService
  );

  const handleToRight = contextSelector((s) => s.handleToRightTargetObjects);
  const handleDeleteTarget = contextSelector(
    (s) => s.handleDeleteTargetObjects
  );

  const syncTargets = contextSelector((s) => s.syncObjectsByService);
  const allTargets = contextSelector(
    (s) => s.availableTargetObjectsGeneral,
    isEqual
  );

  const searchTarget = contextSelector((s) => s.searchObjectsTargetByService);
  const searchTargetResult = contextSelector(
    (s) => s.tempVars.searchTargetObjects,
    isEqual
  );
  const policyTarget = contextSelector(
    policyTargetsSalesforceObjectsSelector,
    isEqual
  );

  return {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
    isSyncButtonShow,
  };
};
